/* eslint-disable */
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { SuperRolesContants } from "../contants";

// Module gate for the Customer Service (CRM / ticketing) module.
//
// Access is decided on `super_role`, the same axis PrivateITOfficerRoute uses.
// Both CUSTOMER_SERVICE and CUSTOMER_SERVICE_HEAD are accepted because the
// backend may model the supervisor either as its own super_role or as a plain
// agent carrying CUSTOMER_SERVICE_HEAD in `role[]` — this passes in both cases.
//
// ADMIN is admitted too, so the support desk is reachable from the admin shell
// (see the "Support Desk" item in RenderAdminPage). This mirrors the server,
// where SupportController is gated @Roles(ROLE.ADMIN, ROLE.CUSTOMER_SERVICE).
//
// `roles` is the optional fine-grained gate (see PrivateLoanAdminRoute). Pass
// it for head-only screens; it is satisfied by `role[]` OR by an equivalent
// `super_role`, again so either backend shape works. An ADMIN always satisfies
// it — a system administrator is not locked out of a departmental screen.
function PrivateCustomerServiceRoute({ component: Component, roles, ...rest }) {
  const user = JSON.parse(window.localStorage.getItem("user") || "{}");
  const hasJWT = () => !!window.localStorage.getItem("token");

  const superRole = user?.super_role;
  const isAdmin = superRole === SuperRolesContants.ADMIN;
  const isCustomerService =
    isAdmin ||
    superRole === SuperRolesContants.CUSTOMER_SERVICE ||
    superRole === SuperRolesContants.CUSTOMER_SERVICE_HEAD;

  const hasRole = () => {
    if (!roles || roles.length === 0) return true;
    if (isAdmin) return true;
    const userRoles = user?.role || [];
    return roles.some((r) => userRoles.includes(r) || superRole === r);
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        hasJWT() && isCustomerService ? (
          hasRole() ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: "/support/home" }} />
          )
        ) : (
          <Redirect to={{ pathname: "/" }} />
        )
      }
    />
  );
}

export default PrivateCustomerServiceRoute;
